import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { InterviewService } from "../../services/InterviewService";
import { toast } from "react-toastify";

const ModalCreateContact = ({ showModal, setShowModal, interviewId }) => {
  const [createContact, setCreateContact] = useState({
    interviewId: interviewId,
    comment: ""
  });
  const { t } = useTranslation();

  const onChangeComment = ({ target }) => {
    setCreateContact({ ...createContact, comment: target.value });
  };

  const submitButtonActionFunction = () => {
    if (createContact.comment !== "") {
      setShowModal(false);
      InterviewService.createContact(createContact)
        .then((result) => {
          if (result?.error) {
            toast.error(t("An inexpected error occurred"));
          } else {
            toast.success(t("Saved Successfully"));
            setCreateContact({ ...createContact, comment: "" });
          }
        })
        .catch(() => {
          toast.error(t("An inexpected error occurred"));
        });
    } else {
      toast.warning(t("The comment is required"));
    }
  };

  return (
    <ModalContainer
      modalTitle={t("New Contact")}
      isOpen={showModal}
      submitButtonAction={() => submitButtonActionFunction()}
      submitButtonTitle={t("Save")}
      submitButtonType="button"
      cancelButtonAction={() => setShowModal(false)}
      cancelButtonTitle={t("Cancel")}
      closeModal={() => setShowModal(false)}
      crossmarkAction={() => setShowModal(false)}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="form-label">{t("Comments")}</label>
        </div>
        <textarea
          onChange={onChangeComment}
          value={createContact.comment || ""}
          name="comment"
        ></textarea>
      </div>
    </ModalContainer>
  );
};

export default ModalCreateContact;
